import DateTime from '~/components/DateTime';
import UserInfo from '~/components/UserInfo';

export default [
  item => <DateTime datetime={item.createdAt} />,
  item => <UserInfo user={item.createdBy} />,
  item => <DateTime datetime={item.updatedAt} />,
  item => <UserInfo user={item.updatedBy} />,
];
